import { curry, getFirstItem, setKey } from 'lib/util'
import { setData } from 'lib/sequence/model/api/set'
import find from 'lib/sequence/component/children/find'

/**
 * Stores the serial of an equipment `item` and the name of its product in the model's
 * itemData attribute. It also stores their keys in the corresponding (equipment and product) model
 * refs.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const selectItem = async (module, component, eventOrItem) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const model = module[G.MODEL]
  const { request } = model[G.CHILDREN]
  const { equipment, product } = request[G.CHILDREN]

  const { resultsModal } = find(actionComponent)
  const { item: selectedItem = eventOrItem || {} } = eventOrItem?.detail || {}
  // obtaining equipment data
  const { key: equipmentKey = null, value = {}, refs: { product: productRef } = {} } = selectedItem
  const { serial, name: equipmentName = 'Unknown', serialDistinction, numberCommission } = value
  // obtaining product data
  const currentProduct = getFirstItem(productRef) || {}
  const { key: productKey = null, value: productValue = {} } = currentProduct
  const { name = equipmentName } = productValue
  // setting model data
  const itemData = { serial, name, serialDistinction, numberCommission }
  const serialValue = serial || numberCommission
  setData(model, { request: { itemData: serialValue ? itemData : null } })
  setKey(equipmentKey, G.REF, equipment[G.STATE])
  currentProduct && setKey(productKey, G.REF, product[G.STATE])

  setKey(false, 'open', resultsModal[G.STATE])

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(selectItem)
